import { render } from "./accountButton.vue?vue&type=template&id=12759b58&scoped=true"
import script from "./accountButton.vue?vue&type=script&lang=js"
export * from "./accountButton.vue?vue&type=script&lang=js"

import "./accountButton.vue?vue&type=style&index=0&id=12759b58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12759b58"

export default script